export default {
    namespaced:true, //开启后，该模块就成为命名空间模块了
    state:{
        navList:[],                // 全部路由
        fourRouteList:[],         // 三级路由
        routeLevel:[],             // 路由层级 [第一级ID,第二级ID,第三级ID,第四级ID]
    },
    getters: {
        fourRouteList: state => state.fourRouteList,
        navList: state => state.navList,
        routeLevel: state => state.routeLevel,
    },
}